import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'
import useSectionNav from '../hooks/useSectionNav'
import { CONTACT, LEGAL_PAGES } from '../siteConfig'

const COMPANY_LINKS = [
    { id: 'home', label: 'Home' },
    { id: 'features', label: 'Features' },
    { id: 'testimonials', label: 'Our Farmers' },
    { id: 'contact', label: 'Contact' },
]

const FEATURE_LINKS = ['Live Rates', 'Farm & Flock Management', 'Vet Booking', 'Marketplace']

const Footer = () => {
    const goToSection = useSectionNav()

    const handleSection = (e, id) => {
        e.preventDefault()
        goToSection(id)
    }

    return (
        <footer className="site-footer">
            <div className="wrap">
                <div className="foot-grid">
                    <div>
                        <div className="foot-logo"><Logo light /></div>
                        <p className="foot-about">Poultryfy is India's biggest poultry marketplace, made for the betterment of the poultry industry and poultry farmers in India.</p>
                    </div>
                    <div className="foot-col">
                        <h5>Company</h5>
                        <ul>
                            {COMPANY_LINKS.map(({ id, label }) => (
                                <li key={id}><a href="#/" onClick={(e) => handleSection(e, id)}>{label}</a></li>
                            ))}
                        </ul>
                    </div>
                    <div className="foot-col">
                        <h5>Features</h5>
                        <ul>
                            {FEATURE_LINKS.map((label) => (
                                <li key={label}><a href="#/" onClick={(e) => handleSection(e, 'features')}>{label}</a></li>
                            ))}
                        </ul>
                    </div>
                    <div className="foot-col">
                        <h5>Legal</h5>
                        <ul>
                            {LEGAL_PAGES.map(({ to, label }) => (
                                <li key={to}><Link to={to}>{label}</Link></li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="foot-bottom">
                    <span>© {new Date().getFullYear()} Poultryfy — {CONTACT.company}. All Rights Reserved.</span>
                    <span>{CONTACT.address} · {CONTACT.phone}</span>
                </div>
            </div>
        </footer>
    )
}

export default Footer
